var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var NetlistData = require("./netlist/netlistData.js");
var NetData = require("./netlist/netData.js");
var CircuitMetaData = require("./circuitMetaData.js");
var SchematicData = require("./schematic/schematicData.js");
var PcbData = require("./pcb/pcbData.js");

var CircuitData = function (init) {
    var self = this;

    this.makeObservableTreeNode();

    this.metaData = this.value("metaData", true);

    // this.logicTerminals = this.set("logicTerminals", true, true);
    this.properties = this.set("properties", true);

    this.netlist = this.value("netlist", true);
    this.schematicData = this.value("schematicData", true);
    this.pcbData = this.value("pcbData", true);

    this.isComplete = this.shadow("isComplete",
        function() {
            return true;
        }, null,
        [[this, this.onBubble]]
    );

    if (init) {
        var metaData = new CircuitMetaData("New Circuit");
        metaData.summary("");
        metaData.description("");
        this.metaData(metaData);
        this.netlist(new NetlistData());
        this.schematicData(new SchematicData());
        this.pcbData(new PcbData(true, 4));
    }
};
lib_core.mixin(CircuitData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(CircuitData, "CircuitData");

module.exports = CircuitData;

CircuitData.prototype.getBoundingBox = function() {
    return null; // TODO: remove this
};

CircuitData.prototype.getExplodedJSON = function() {
    var json = this.jsonify();
    return json;
};
